module.exports = __webpack_public_path__ + "static/media/AdobeStock_1634742965.50f28082.webp";